// ── Shared hook for AI pattern generation ─────────────────────
// Used by both PatternsTab (Settings) and PatternPalette (Plan screen).

import { useState, useCallback } from 'react';
import { authFetch } from '../api';

const API_URL = process.env.REACT_APP_API_URL || '';

export default function usePatternGenerate() {
  const [patterns, setPatterns] = useState([]);
  const [generating, setGenerating] = useState(false);

  const loadPatterns = useCallback(async () => {
    try {
      const res = await authFetch(`${API_URL}/api/patterns`);
      const data = await res.json();
      const list = Array.isArray(data) ? data : [];
      setPatterns(list);
      return list;
    } catch {
      setPatterns([]);
      return [];
    }
  }, []);

  const generate = useCallback(async (description) => {
    if (!description.trim()) return null;
    setGenerating(true);
    try {
      const res = await authFetch(`${API_URL}/api/pattern/generate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ description }),
      });
      const data = await res.json();
      if (data.pattern) {
        // Auto-save to pattern store
        await authFetch(`${API_URL}/api/patterns`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ definition: data.pattern }),
        });
        // Refresh list
        await loadPatterns();
        return data.pattern;
      }
      return null;
    } catch (err) {
      throw err;
    } finally {
      setGenerating(false);
    }
  }, [loadPatterns]);

  return { patterns, generating, loadPatterns, generate };
}
